<div class="sw-wrap">
  <h3 class="sw-heading" *ngIf="heading">{{ heading }}</h3>

  <div class="saturation-wheel">
    <div class="sw-stage">
      <svg class="sw-svg" viewBox="0 0 260 260" role="img" aria-label="Saturation wheel">
        <path class="sw-cell" *ngFor="let c of cells"
              [attr.d]="c.d" [attr.fill]="c.hex"
              (click)="select( c )"></path>
        <!-- The picked cell, redrawn on top so it grows in place above its
             neighbours (about its own centre) instead of carrying an outline. -->
        <path class="sw-cell-pop" [attr.d]="selected.d" [attr.fill]="selected.hex"
              [style.transform-origin]="selected.cx + 'px ' + selected.cy + 'px'"></path>
      </svg>

      <!-- Centre disc: the picked colour, with its saturation read across it. -->
      <div class="sw-center" [style.background]="centerHex">
        <span class="sw-center-pct" [class.sw-center-dark]="centerDark">{{ selected.sat }}%</span>
      </div>
    </div>

    <p class="sw-readout">
      <span class="sw-chip" [style.background]="centerHex"></span>
      <span class="sw-sat">{{ selected.sat }}% saturated</span>
      <span class="sw-hex">{{ centerHex }}</span>
    </p>
  </div>
</div>
